export default "__VITE_ASSET__DUjdIeHz__"